import React from 'react';
import { useSelector } from 'react-redux';

// Selectors
// @ts-ignore
import { makeSelectDocumentSetValue } from 'services/documentSets/selectors';

import EventCreatedBy from 'components/EventCreatedBy';

import { AppState } from 'services/types';

interface Props {
    documentSetId: number; // eslint-disable-line
}

export default function DocumentSetEventCreatedBy(
    props: Props
): React.ReactElement | null {
    const eventId = useSelector((state: AppState) =>
        makeSelectDocumentSetValue('eventId')(state, props)
    );

    if (!eventId) return null;

    return <EventCreatedBy eventId={eventId} />;
}
